
import { GspRoleDataState } from './types';

export const state = (): GspRoleDataState => initialState();

export const initialState = (): GspRoleDataState => ({
  gspRolesData: {
    items: [],
    isLoading: false,
    total: 2, //TODO remove when was made backend
    searchParams: {
      dataOption: {
        page: 1,
        itemsPerPage: 200,
        sortBy: [],
        sortDesc: [false],
        groupBy: [],
        groupDesc: [],
        multiSort: true,
        mustSort: false,
      },
      filter: '',
      orClauseFieldsIds: [],
      andClauseFieldsIds: [],
    },
  },
});
